export default {
  init() {

    $(document).bind( 'gform_confirmation_loaded', this.gaOnConfirmation );

  },

  gaOnConfirmation( event, formID ) {

    if ( typeof window.gtag === "function" ) {

      switch( formID ) {
        case 1:
          window.gtag('event', 'Submission', {
            'event_category': 'Form',
            'event_label': 'Contact',
            'value': '0',
          });

          break;

        case 2:
          // do something here
          break;

        default:
          break;
      }
    }

  },
}



// WEBPACK FOOTER //
// ./scripts/modules/analytics.js